import initScrollReveal from "./scripts/scrollReveal";
import { defaultProps, targetElements } from "./scripts/scrollRevealConfig";
import initTiltEffect from "./scripts/tiltAnimation";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

// Rolling text animation for hero section
const rollingKeywords = [
  "passionate Software Engineer",
  "Backend Developer",
  "Pythonista",
  "Full Stack Developer",
  "Debugger Ninja",
  "Open Source Enthusiast",
  "DevOps Practitioner",
  "Cloud Native Builder",
  "Homelab Enthusiast",
  "AI & Machine Learning Explorer",
  "Automation Fanatic",
  "Test-Driven Troubleshooter",
  "JavaScript Lover",
  "Linux User",
  "Retro Gaming Fan",
  "API Designer",
  "Self-Hosting Advocate",
  "System Design Thinker",
  "Problem Solver",
  "Tech Explorer",
];
let rollingIndex = 0;
const rollingTextElem = document.getElementById("rolling-text");

function showNextKeyword() {
  if (rollingTextElem) {
    rollingTextElem.textContent = rollingKeywords[rollingIndex];
    rollingIndex = (rollingIndex + 1) % rollingKeywords.length;
  }
}
if (rollingTextElem) {
  setInterval(showNextKeyword, 2000); // Change every 2 seconds
}

// Contact form submission
const contactForm = document.getElementById("contact-form");
if (contactForm) {
  contactForm.addEventListener("submit", (e) => {
    setTimeout(() => {
      contactForm.reset();
    }, 200); // Reset form after x second to allow submission to go through
  });
}
